<template>
  <!--      Modal Actual -->
  <b-modal
    id="deposit-details-modal"
    ref="modal"
    v-model="open"
    size="md"
    no-close-on-backdrop
    hide-footer
    :title="modalTitle"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <section>
        <b-card
          id="invoice-preview-card"
          no-body
          class="invoice-preview-card"
        >
          <b-card-body
            class="invoice m-2"
          >
            <b-row>
              <b-col
                cols="12"
                md="12"
                class="pt-1"
              >
                <div>
                  <table>
                    <tbody>
                      <tr style="margin-bottom:3px;">
                        <td class="pr-1">
                          Total Number of Orders:
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ depositData.no_of_orders }}</span>
                        </td>
                      </tr>
                      <tr style="margin-bottom:3px;">
                        <td class="pr-1">
                          Total Collected COD:
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ __numberWithCommas(depositData.total_collected_cod, true) }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="type === 'rider'"
                        style="margin-bottom:4px;"
                      >
                        <td class="pr-1">
                          Rider Commission: (-)
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ __numberWithCommas(depositData.rider_commission, true) }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="type === 'merchant'"
                        style="margin-bottom:4px;"
                      >
                        <td class="pr-1">
                          Total Merchant Commission: (-)
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(depositData.merchant_commission, true) }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="type === 'agent'"
                        style="margin-bottom:4px;"
                      >
                        <td class="pr-1">
                          Total Agency Commission: (-)
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(depositData.agency_commission, true) }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="type === 'branch'"
                        style="margin-bottom:4px;"
                      >
                        <td class="pr-1">
                          Total Rider Commission: (-)
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(depositData.rider_commission, true) }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="type === 'merchant'"
                        style="margin-bottom:4px;"
                      >
                        <td class="pr-1">
                          Total Delivery Charge:
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(depositData.total_delivery_charge, true) }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="type === 'merchant' && depositData.tax_breakdown != null"
                        style="margin-bottom:4px;"
                      >
                        <td class="pr-1">
                          Total Tax Amount:
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(depositData.total_tax_applied, true) }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="type === 'merchant' && depositData.tax_breakdown != null"
                        style="margin-bottom:4px;"
                      >
                        <td class="pr-1">
                          Total Amount After Tax:
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(depositData.invoice_amount_after_taxes, true) }}</span>
                        </td>
                      </tr>
                      <div style="height:2px;" />
                      <tr>
                        <td class="pr-1">
                          <h6 class="font-weight-bolder">
                            NET Payable:
                          </h6>
                        </td>
                        <td class="w-50 pl-2 text-right">
                          <span class="font-weight-bolder">{{ __numberWithCommas(depositData.net_payable, true) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <!-- Right Col: Card -->
        <b-col
          cols="12"
          md="4"
          xl="4"
        >
          <!-- Button: Confirm -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-success"
            class="mb-75"
            block
            @click="onSubmit"
          >
            Generate
          </b-button>
        </b-col>
      </section>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BCard,
  BButton,
  BModal,
  BCol,
  BCardBody,
  BRow,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const FinanceRepository = RepositoryFactory.get('finance')

function initialState() {
  return {
    open: false,
    modalLoading: false,
    selectedWaybills: [],
    submitFunction: () => {},
    deposit: {},
    type: null,
    depositData: {},
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BCard,
    BButton,
    BModal,
    BCol,
    BCardBody,
    BRow,
    BOverlay,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  computed: {
    modalTitle() {
      return this.type === 'merchant' ? 'Invoice Details' : 'Deposit Details'
    },
  },
  async created() {
    this.id = this.$route.params.id
    this.businessSettings = JSON.parse(localStorage.getItem('businessSettings'))
    this.companyCurrency = this.businessSettings.company_currency
  },
  methods: {
    async openModal(selectedWaybills, submitFunction, deposit, type) {
      await Object.assign(this.$data, initialState())
      this.open = true
      this.selectedWaybills = selectedWaybills
      this.submitFunction = submitFunction
      this.deposit = deposit
      this.type = type
      this.getDepositDetails()
    },
    async getDepositDetails() {
      this.modalLoading = true
      try {
        const payload = {
          waybill_numbers: this.selectedWaybills,
        }
        let data
        if (this.type === 'rider') {
          data = (await FinanceRepository.getRiderDepositDetailsBeforeSubmit(payload)).data.data
        } else if (this.type === 'agent') {
          data = (await FinanceRepository.getAgentDepositDetailsBeforeSubmit(payload)).data.data
        } else if (this.type === 'branch') {
          data = (await FinanceRepository.getBranchDepositDetailsBeforeSubmit(payload)).data.data
        } else if (this.type === 'merchant') {
          data = (await FinanceRepository.getInvoiceDetailsBeforeSubmit(payload)).data.data
        }
        this.depositData = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    async onSubmit() {
      try {
        this.modalLoading = true
        await this.submitFunction(this.deposit)
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
  },
}
</script>
